import React from 'react'
import {Row, Col} from 'react-bootstrap'
import no_image from '../../../assets/img/no_photo.png'

const OrderDetailRow = ({item}) => {
  const image = item.links.photo || no_image;

  return (
    <div className="order-details-row">
      <Row>
        <Col sm={2} xs={12}>
          <img src={image} alt="No image" className="product-image"/>
        </Col>
        <Col sm={10} xs={12}>
          <div className="product-name">
            <strong>{item.name}</strong>
          </div>
          <Row>
            <Col sm={3} xs={12}>
                <div className="line-item-rsp">RSP €{item['product-rsp']}</div>
            </Col>
            <Col sm={5} xs={12}>
                <div className="qty-value">Quantity {item['product-qty']}</div>
            </Col>
            <Col sm={4} xs={12} className="price-column">
                { item['promotion-is-available'] && (
                  <div className="promotional-price"><strong>Promotional total €{item['total-with-applied-promotion'].toFixed(2)}</strong></div>
                ) }
                <div className={`cost-value ${item['promotion-is-available'] ? 'original-price' : ''}`}><strong>Total €{item['line-total'].toFixed(2)}</strong></div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
};

export default OrderDetailRow


// WEBPACK FOOTER //
// ./src/components/my-orders/view/order-details-row.jsx